import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ov-suite-dashboard',
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
  ngOnInit(): void {}
}
